import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { css } from "styled-components";

export interface HorizontalRuleStyles {
    hrBorder: InjectableCss;
}

export interface HorizontalRuleProps {
    styles?: any;
}

export const horizontalRuleStyles: HorizontalRuleStyles = {
    hrBorder: {
        css: css`
            position: static;
            width: 100%;
            height: 1px;
            top: 0px;
            background: ${UCSColors.gray07};
            margin-top: 8px;
            margin-bottom: 8px;
        `,
    },
};
export const HorizontalRule: React.FC<HorizontalRuleProps> = ({ styles }) => {
    return <StyledWrapper {...horizontalRuleStyles.hrBorder} style={{ ...styles }} />;
};
